























































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import SelectEntity from "@/components/form/SelectEntity.vue";
import { EnrollmentOrder as IEnrollmentOrder } from "@/api/models/enrollment-order";
import { CourseListenerUnion as ICourseListener } from "@/api/models/course-listener-union";
import { Employee as IEmployee } from "@/api/models/employee";
import { CourseListenersUnionList as ICourseListenersList } from "@/api/models/course-listeners-union-list";
import enrollmentsListeners, {
  EnrollmentOrdersListeners
} from "@/getinfo-api/enrollments-listeners";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { EnrollmentOrderEdit as IEnrollmentOrderEdit } from "@/api/models/enrollment-order-edit";
import api, { courseApi } from "@/getinfo-api";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import Modal from "@/components/form/Modal.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CField from "@/components/form/CField.vue";

@Component({
  components: { CField, CustomButton, Modal, SelectEntity, CustomDatepicker }
})
export default class enrollmentOrderFormEdit extends Vue {
  @Prop() enrollmentData!: IEnrollmentOrder;
  ownerId!: string;
  number!: string;
  courses: Array<string> = [];
  limit: number = 1000;
  offset: number = 0;
  showSpinner: boolean = false;
  selectedListeners: Array<string> = [];
  signedAt!: Date | undefined;
  educationStartedAt: Date | undefined = this.enrollmentData.educationStartedAt;
  educationFinishedAt!: Date | undefined;
  formedAt!: Date | undefined;
  employees!: Array<IEmployee> | undefined;
  listeners: Array<ICourseListener> = [];
  activeListeners?: Array<ICourseListener> = [];
  allListeners: Array<ICourseListener> = [];
  isSaving: boolean = false;
  isMounted: boolean = false;
  courseTitle: string = "";

  data() {
    return {
      ownerId: undefined,
      number: undefined,
      signedAt: undefined,
      formedAt: undefined,
      educationFinishedAt: undefined,
      employees: undefined
    };
  }

  deleteEnrollment() {
    api.EnrollmentOrderApi._delete(this.enrollmentData?.id)
      .then(() => {
        this.$router.push({ name: "enrollmentList" });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      });
  }

  @Watch("educationStartedAt")
  checkEducationStartedAt() {
    if (!this.isMounted) {
      this.isMounted = true;
    } else {
      this.selectedListeners = [];
    }
  }

  selectAll(event: boolean) {
    if (event) {
      this.selectedListeners = this.listenersByDate.map(el => el.id);
    } else {
      this.selectedListeners = [];
    }
  }

  addListener(listenerId: string) {
    if (!this.selectedListeners.includes(listenerId)) {
      this.selectedListeners.push(listenerId);
    } else {
      this.selectedListeners = this.selectedListeners.filter(
        el => el !== listenerId
      );
    }
  }

  getStatus(listener: ICourseListener) {
    let status: string = "";
    if (listener.status === "success")
      status = `${this.$tc(this.$translate.Completed)}`;
    if (listener.status === "learning")
      status = `${this.$tc(this.$translate.Learning)}`;
    if (listener.status === "not_success")
      status = `${this.$tc(this.$translate.CompletedUnsuccessfully)}`;
    return status;
  }

  get selectedCourses() {
    return this.enrollmentData?.courseId;
  }

  checkSelected(listenerId: string) {
    return this.selectedListeners.includes(listenerId);
  }

  getEnrollmentListeners(offset: number = 0) {
    this.showSpinner = true;
    let params: EnrollmentOrdersListeners = {
      courseId: this.enrollmentData?.courseId,
      hasProtocol: false,
      offset: offset,
      limit: this.limit
    };
    enrollmentsListeners(params)
      .then((res: { data: ICourseListenersList }) => {
        res.data.listeners.forEach((el: ICourseListener) => {
          this.allListeners.push(el);
          this.listeners.push(el);
        });
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  get listenersByDate() {
    let arr: Array<ICourseListener> = [];
    this.listeners?.forEach(el => {
      let listenersStarted = new Date(el.createdAt);
      listenersStarted.setHours(0, 0, 0, 0);
      if (
        this.educationStartedAt &&
        listenersStarted.toDateString() ===
          new Date(this.educationStartedAt).toDateString()
      ) {
        arr.push(el);
      }
    });
    return arr;
  }

  getActiveEnrollmentListeners() {
    this.activeListeners = this.enrollmentData
      ? this.enrollmentData.listeners
      : [];
    this.activeListeners?.forEach(el => {
      this.listeners.unshift(el);
      this.selectedListeners.push(el.id);
    });
  }

  get selectedCompany() {
    return this.$store.getters.selectedCompany?.id
      ? this.$store.getters.selectedCompany.id
      : localStorage.getItem("selectedCompany");
  }

  created() {
    this.getEnrollmentListeners();
    this.getActiveEnrollmentListeners();
    this.signedAt = this.enrollmentData.signedAt;
    this.formedAt = this.enrollmentData.formedAt;
    this.number = this.enrollmentData.number;

    if (this.enrollmentData.courseVersion === "v2") {
      courseApi.Course.getCourse(this.enrollmentData.courseId).then(
        ({ data }) => {
          this.courseTitle = data.title;
        }
      );
    }
  }

  enrollmentEdit() {
    if (this.formedAt !== undefined) {
      this.isSaving = true;
      const edit: IEnrollmentOrderEdit = {
        ownerId: this.enrollmentData.ownerId,
        formedAt: this.formedAt,
        number: this.number,
        signedAt: this.signedAt,
        educationFinishedAt: this.educationFinishedAt,
        educationStartedAt: this.educationStartedAt,
        listeners: this.selectedListeners,
        courseId: this.enrollmentData.courseId,
        fileIds: this.enrollmentData.files?.map((el: any) => el.id)
      };
      api.EnrollmentOrderApi.edit(this.enrollmentData.id, edit)
        .then((res: { data: IEnrollmentOrder }) => {
          this.$router.push({
            name: "enrollmentOrder",
            params: { enrollmentId: res.data.id }
          });
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.isSaving = false;
        });
    } else {
      this.$store.dispatch(
        "localError",
        `${this.$tc(this.$translate.TheFormedFieldIsRequired)}`
      );
    }
  }
}
